stripLoc